// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1JjSC","total":"Cart_total__1GzZr","actions":"Cart_actions__3Yqvs","button--alt":"Cart_button--alt__1jjZb","button":"Cart_button__1CSZe"};